import {
  ISelectMiniMultiOption,
  ISelectMiniOption,
  ISelectMultiOption,
  ISelectOption,
} from '@salecycle/ui-component-library';

export const compare = (labelA: string | number, labelB: string | number): number => {
  let comparison = 0;
  if (labelA > labelB) {
    comparison = 1;
  } else if (labelA < labelB) {
    comparison = -1;
  }
  return comparison;
};

type Option = ISelectOption<any> | ISelectMiniOption | ISelectMiniMultiOption | ISelectMultiOption<any>;

/** Sorts the options in a select by the `label` value. */
export const sortOptions = (a: Option, b: Option): number => {
  return compare(a.label.toLowerCase(), b.label.toLowerCase());
};
